<template>
  <header class="site-header">
    <!-- 顶部信息栏 -->
    <div class="header-top hidden-mobile">
      <div class="container">
        <div class="header-top-links">
          <a href="https://www.lnjkjt.com/" target="_blank" class="top-link">
            <i class="el-icon-office-building"></i> 金控集团官网
          </a>
          <div class="top-link qr-hover-wrapper">
            <i class="el-icon-connection"></i> 推介平台
            <div class="qr-code-dropdown">
              <div class="qr-inner">
                <img :src="$store.state.siteConfig.showMiniapp" alt="小程序二维码" />
                <p>扫码了解更多</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主导航区 -->
    <div class="header-main">
      <div class="container">
        <!-- Logo -->
        <div class="site-logo" @click="$router.push('/')">
          <img :src="$store.state.siteConfig.showLogo || require('@/assets/imgs/logo.png')" 
               alt="辽宁资产管理有限公司" 
               class="logo-img" 
               @error="$event.target.src = require('@/assets/imgs/logo.png')" />
        </div>

        <!-- 导航菜单 (PC) -->
        <nav class="main-nav hidden-mobile" v-if="!isMobile">
          <ul>
            <li>
              <router-link
                to="/"
                :class="{ active: $route.path === '/' }"
              >首页</router-link>
            </li>
            <li v-for="menu in menuList" :key="menu.id">
              <a v-if="menu.isExternal" :href="menu.path" target="_blank">{{ menu.menuName }}</a>
              <router-link
                v-else
                :to="{ path: menu.path, query: { id: menu.scode } }"
                :class="{ active: $route.path === menu.path }"
              >{{ menu.menuName }}</router-link>
            </li>
          </ul>
        </nav>

        <!-- 搜索框 & 汉堡按钮 -->
        <div class="header-actions">
          <div class="search-box hidden-mobile" v-if="!isMobile">
            <input type="text" v-model="keyword" placeholder="搜索内容、标题..." @keyup.enter="doSearch" />
            <button @click="doSearch"><i class="el-icon-search"></i></button>
          </div>
          <button class="mobile-menu-btn hidden-pc" @click="mobileMenuOpen = !mobileMenuOpen" v-if="isMobile">
            <i :class="mobileMenuOpen ? 'el-icon-close' : 'el-icon-s-unfold'"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 移动端侧边抽屉式菜单 -->
    <el-drawer
      title="导航菜单"
      :visible.sync="mobileMenuOpen"
      direction="rtl"
      size="65%"
      class="mobile-drawer-nav"
      v-if="isMobile"
      append-to-body
    >
      <div class="mobile-search-container">
        <div class="search-box">
          <input type="text" v-model="keyword" placeholder="搜索内容、标题..." @keyup.enter="doSearchMobile" />
          <button @click="doSearchMobile"><i class="el-icon-search"></i></button>
        </div>
      </div>
      <nav class="mobile-nav">
        <ul>
          <li>
            <router-link
              to="/"
              :class="{ active: $route.path === '/' }"
              @click.native="mobileMenuOpen = false"
            >首页</router-link>
          </li>
          <li v-for="menu in menuList" :key="menu.id">
            <a v-if="menu.isExternal" :href="menu.path" target="_blank" @click="mobileMenuOpen = false">{{ menu.menuName }}</a>
            <router-link
              v-else
              :to="{ path: menu.path, query: { id: menu.scode } }"
              :class="{ active: $route.path === menu.path }"
              @click.native="mobileMenuOpen = false"
            >{{ menu.menuName }}</router-link>
          </li>
        </ul>
      </nav>
    </el-drawer>
  </header>
</template>

<script>
import { getLabelList } from '@/api/menu'
export default {
  name: 'NavBar',
  data() {
    return {
      keyword: '',
      isMobile: false,
      mobileMenuOpen: false,
      menuLoading: false,
      // miniapp: ''
    }
  },
  computed: {
    menuList() {
      return this.$store.state.menuList
    }
  },
  async created() {
    await this.fetchMenu()
    // this.fetchContactLabel('miniapp');
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    // async fetchContactLabel(name) {
    //   try {
    //     const res = await getLabelList({ name })
    //     if (res.code === 0 && res.data) {
    //       this.miniapp = res.data.value;
    //     }
    //   } catch (error) {
    //     console.error(`获取${name}失败:`, error)
    //   }
    // },
    async fetchMenu() {
      this.menuLoading = true
      try {
        await this.$store.dispatch('fetchMenuList')
      } catch (e) {
        console.error('加载菜单失败:', e)
      } finally {
        this.menuLoading = false
      }
    },
    checkMobile() {
      // 统一使用 1000px 作为移动端断点
      this.isMobile = window.innerWidth <= 1000
      if (!this.isMobile) this.mobileMenuOpen = false
    },
    doSearch() {
      // if (this.keyword.trim()) {
        this.$router.push({ path: '/search', query: { keyword: this.keyword } })
      // }
    },
    doSearchMobile() {
      this.mobileMenuOpen = false;
      this.doSearch();
    }
  }
}
</script>

<style lang="scss" scoped>
/* ---- 变量 ---- */
$dark-blue: #1a3a5c;
$blue:      #1e6fa2;
$top-bg:    #1e3a5f;
$border:    #e8edf3;
$active-red: #1a3a5c;

.site-header {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
  position: sticky;
  top: 0;
  z-index: 1000;
}

/* ---- 顶部信息栏 ---- */
.header-top {
  background: $top-bg;
  padding: 6px 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }

  .header-top-links {
    display: flex;
    gap: 20px;
  }

  .top-link {
    color: rgba(255,255,255,.85);
    font-size: .78rem;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: color .2s;
    i { font-size: .9rem; }
    &:hover { color: #fff; }
  }

  /* 二维码悬浮样式 */
  .qr-hover-wrapper {
    position: relative;
    cursor: pointer;
    
    .qr-code-dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      padding-top: 10px;
      visibility: hidden;
      opacity: 0;
      transform: translateY(10px);
      transition: all 0.3s ease;
      z-index: 200;
      
      .qr-inner {
        background: #fff;
        padding: 12px;
        border-radius: 8px;
        box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        text-align: center;
        width: 140px;
        border: 1px solid #eee;

        img {
          width: 110px;
          height: 110px;
          display: block;
          margin: 0 auto 8px;
        }

        p {
          margin: 0;
          color: #333;
          font-size: 0.75rem;
          font-weight: 500;
        }
      }
    }

    &:hover {
      color: #fff;
      .qr-code-dropdown {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}

/* ---- 主导航区 ---- */
.header-main {
  background: #fff;
  border-bottom: 1px solid $border;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    height: 75px;
    gap: 30px;
  }
}

/* ---- Logo ---- */
.site-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  flex-shrink: 0;

  .logo-img {
    height: 50px;
    width: 280px;
    object-fit: contain;
  }

  .logo-text {
    display: flex;
    flex-direction: column;

    .logo-cn {
      font-size: 1.25rem;
      font-weight: 700;
      color: $dark-blue;
      letter-spacing: .05em;
      line-height: 1.3;
    }

    .logo-en {
      font-size: .65rem;
      color: $blue;
      letter-spacing: .03em;
      line-height: 1.6;
    }
  }

  &:hover {
    opacity: 0.9;
  }
}

/* ---- 主导航菜单 ---- */
.main-nav {
  flex: 1;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    gap: 0;
    height: 75px;
  }

  li a {
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    font-size: .93rem;
    color: #333;
    text-decoration: none;
    position: relative;
    transition: color .2s;
    white-space: nowrap;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 3px;
      background: $active-red;
      transition: width .25s ease;
    }

    &:hover {
      color: $blue;
      &::after { width: 80%; }
    }

    &.active {
      color: $dark-blue;
      font-weight: 700;
      &::after { width: 80%; }
    }
  }
}

/* ---- 搜索框 ---- */
.header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.search-box {
  display: flex;
  align-items: center;
  border: 1px solid $border;
  border-radius: 4px;
  overflow: hidden;

  input {
    padding: 6px 12px;
    font-size: .82rem;
    border: none;
    outline: none;
    width: 160px;
    color: #444;
    background: $border;
  }

  button {
    background: $top-bg;
    border: none;
    color: #fff;
    padding: 7px 12px;
    cursor: pointer;
    font-size: .9rem;
    transition: background .2s;
    &:hover { background: $dark-blue; }
  }
}

/* ---- 汉堡按钮 ---- */
.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: $dark-blue;
  cursor: pointer;
  padding: 4px;
}

/* ---- 移动端展开菜单 ---- */
.mobile-drawer-nav {
  ::v-deep .el-drawer__header {
    margin-bottom: 0;
    padding: 15px 20px;
    font-size: 1.1rem;
    color: $dark-blue;
    font-weight: bold;
    border-bottom: 1px solid $border;
  }
}

.mobile-search-container {
  padding: 15px 20px 5px;
  
  .search-box {
    display: flex;
    align-items: center;
    border: 1px solid $border;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;

    input {
      flex: 1;
      padding: 8px 12px;
      font-size: 0.95rem;
      border: none;
      outline: none;
      color: #444;
      background: $border;
    }

    button {
      background: $dark-blue;
      border: none;
      color: #fff;
      padding: 9px 15px;
      cursor: pointer;
      font-size: 1rem;
      transition: background .2s;
      &:hover { background: $dark-blue; }
    }
  }
}

.mobile-nav {
  ul {
    list-style: none;
    margin: 0;
    padding: 8px 0;

    li a {
      display: block;
      padding: 13px 20px;
      font-size: 1rem;
      color: #333;
      text-decoration: none;
      border-bottom: 1px solid $border;
      transition: background .2s, color .2s;

      &:hover { background: #f5f8fc; color: $blue; }
      &.active { color: $dark-blue; font-weight: 700; border-left: 4px solid $active-red; padding-left: 16px; background-color: #f8f9fb; }
    }
  }
}

/* ============ Tablet (1001–1150px) ============ */
@media (max-width: 1150px) and (min-width: 1001px) {
  .header-main .container { gap: 15px; }
  .site-logo .logo-img { width: 220px; }
  .main-nav li a { padding: 0 10px; font-size: .85rem; }
  .search-box input { width: 110px; }
}


/* ============ Mobile & Tablet (≤ 1000px) ============ */
@media (max-width: 1000px) {
  .header-top { display: none; }

  .header-main .container {
    height: 60px;
    gap: 12px;
    justify-content: space-between;
  }

  .site-logo {
    .logo-img { 
      height: 36px; 
      width: 200px; /* 进一步缩小 Logo 宽度，为汉堡菜单留出空间 */
    }
    .logo-text {
      .logo-cn { font-size: .95rem; }
      .logo-en { display: none; }
    }
  }
  
  .header-actions {
    z-index: 10; /* 提升操作区层级 */
  }
}

/* 强力显隐控制类 */
@media (min-width: 1001px) {
  .hidden-pc { display: none !important; }
}
@media (max-width: 1000px) {
  .hidden-mobile { display: none !important; }
  .site-header {
    height: 60px !important;
    overflow: hidden;
  }
}
</style>
